export const calculateYoYChange = (current, previous) => {
  if (previous === 0) {
    if (current === 0) return { percentage: "0%", rawPercentage: 0 };
    return { percentage: "N/A", rawPercentage: null }; // Handle division by zero
  }
  const change = ((current - previous) / previous) * 100;
  return {
    percentage: change.toFixed(1) + "%",
    rawPercentage: change,
  };
};
